import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

const emulatorHost =
  process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST || ""

if (emulatorHost) {
  const emulatorUrl = emulatorHost.startsWith('http')
    ? emulatorHost
    : `http://${emulatorHost}`;
  connectAuthEmulator(auth, emulatorUrl);
}
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
const appCheckInstance = process.env.NODE_ENV !== 'development' && recaptchaSiteKey
  ? initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  : null;

/**
 * Returns App Check headers if available, empty object otherwise.
 * Failures are logged but never block the caller.
 */
const getAppCheckHeaders = async () => {
  if (!appCheckInstance) return {};
  try {
    const appCheckTokenResponse = await getToken(appCheckInstance, false);
    return { 'X-Firebase-AppCheck': appCheckTokenResponse.token };
  } catch (err) {
    console.error('App Check token error:', err);
    return {};
  }
};

export { appCheckInstance, getAppCheckHeaders };
export default app;
